/* import __COLOCATED_TEMPLATE__ from './admin-meta.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();